import { httpClient, reportAxios } from "ultis/axios";

const getListPhoneNumber = (params) => {
  return httpClient.get("/cloud-pbx/number", {
    params,
  });
};

const getListPhoneNumberV1 = (params) => {
  return reportAxios.get("/api/v1/numbers", {
    params,
  });
};

export const PhoneNumberApi = {
  getListPhoneNumber,
  getListPhoneNumberV1,
};
